import { Icon } from '../../../components/ui';

/**
 * Cabecalho de coluna ordenavel (`th` com botao e `aria-sort`).
 *
 * O botao e o alvo do teclado (Enter/Espaco); `aria-sort` fica no `th`, que e
 * onde o leitor de tela procura. O glifo muda com o sentido e some nas
 * colunas inativas para nao parecer que todas estao ordenadas.
 */
export function ColunaOrdenavel<C extends string>({
  coluna,
  rotulo,
  ativa,
  desc,
  onOrdenar,
  alinhamento = 'esquerda',
  className = '',
}: {
  readonly coluna: C;
  readonly rotulo: string;
  readonly ativa: boolean;
  readonly desc: boolean;
  readonly onOrdenar: (coluna: C) => void;
  readonly alinhamento?: 'esquerda' | 'direita';
  readonly className?: string;
}): JSX.Element {
  return (
    <th scope="col" aria-sort={ativa ? (desc ? 'descending' : 'ascending') : 'none'} className={`px-3 py-2 font-medium ${alinhamento === 'direita' ? 'text-right' : 'text-left'} ${className}`}>
      <button
        type="button"
        onClick={() => onOrdenar(coluna)}
        className={`inline-flex items-center gap-1 rounded uppercase tracking-wide transition-colors hover:text-ink ${ativa ? 'text-ink' : ''}`}
        title={`Ordenar por ${rotulo.toLowerCase()}`}
      >
        {rotulo}
        <Icon name="chevron" size="xs" className={`transition-transform ${ativa ? '' : 'opacity-0'} ${ativa && !desc ? 'rotate-180' : ''}`} />
      </button>
    </th>
  );
}
